import React from "react";

interface InputElementInterface {
  type?: string,
  name?: string,
  placeholder?: string,
  id?: string,
  value: any,
  setValue: (value: any) => void,
  divClass?: string,
  labelClass?: string,
  inputClass?: string,
  disabled?: boolean
}

export const InputElementComplaint: React.FC<InputElementInterface> = ({
  type = "text",
  name,
  id,
  value,
  setValue,
  placeholder,
  divClass = "",
  inputClass = "",
  disabled = false,
  labelClass
}) => {
  const handleInputChange = (e: any) => {
    const inputValue = e.target.value;

    if (type === "date") {
      if (inputValue) {
        const newDate = new Date(inputValue);
        setValue(newDate.toISOString().split("T")[0]);
      }
    } else {
      setValue(e.target.value);
    }
  };

  return (
    <div className={`mb-4 ${divClass}`}>
      {name && (
        <label
          htmlFor={id}
          className={`block text-gray-700 font-semibold text-sm mb-2 ${labelClass}`}
        >
          {name}
        </label>
      )}
      <input
        type={type}
        id={id}
        className={`outline-none w-full px-4 py-3 rounded-lg shadow-md text-gray-800 border border-gray-300 focus:border-main focus:ring-2 focus:ring-main ${inputClass} ${disabled ? 'bg-gray-200 cursor-not-allowed' : ''}`}
        placeholder={placeholder || name}
        value={value}
        autoComplete="off"
        disabled={disabled}
        onChange={handleInputChange}
      />
    </div>
  );
};
